// extracted by mini-css-extract-plugin
export default {"wrapper":"WebApp_wrapper__Pz64g","wrapperInner":"WebApp_wrapperInner__bmOyg"};